/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { ExceptionResponseDTO } from '../model/models';
import { GetProfiloServizio409Response } from '../model/models';
import { GetProfiloServizio422Response } from '../model/models';
import { NotificaPushBroadcastForm } from '../model/models';
import { NotificaPushDestinatariDTO } from '../model/models';
import { NotificaPushSelezioneForm } from '../model/models';
import { NotificaPushUtenteForm } from '../model/models';
import { Pageable } from '../model/models';
import { PagedModelNotificaPushInvioDTO } from '../model/models';


import { Configuration }                                     from '../configuration';


export interface ContaDestinatariNotificaPushRequestParams {
    comuneId?: string;
    userId?: string;
}

export interface GetStoricoNotifichePushRequestParams {
    pageable: Pageable;
}

export interface InviaNotificaPushBroadcastRequestParams {
    notificaPushBroadcastForm: NotificaPushBroadcastForm;
}

export interface InviaNotificaPushSelezioneRequestParams {
    notificaPushSelezioneForm: NotificaPushSelezioneForm;
}

export interface InviaNotificaPushUtenteRequestParams {
    notificaPushUtenteForm: NotificaPushUtenteForm;
}


export interface NotifichePushInvioSUPERADMINServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Conta i destinatari di un invio, senza inviare (SUPERADMIN)
     * Restituisce il numero di dispositivi che un invio raggiungerebbe. Da chiamare prima di confermare l\&#39;invio: e\&#39; irreversibile.  I due filtri sono mutuamente esclusivi e selezionano il tipo di anteprima: - &#x60;user_id&#x60;: dispositivi del singolo cittadino indicato. Uno zero significa che non ha mai installato l\&#39;app o ha disattivato le notifiche. - &#x60;comune_id&#x60; (o nessun filtro): anteprima di un invio globale. Il filtro seleziona i cittadini con almeno una pratica su un bando di quel Comune, NON i residenti: un cittadino registrato che non ha mai presentato domanda non appartiene ad alcun Comune ed e\&#39; raggiungibile solo omettendo il filtro.  Passati entrambi, &#x60;user_id&#x60; vince: e\&#39; una difesa contro un client malformato, non un doppio filtro componibile.  Risposte: - 200: &#x60;NotificaPushDestinatariDTO&#x60;. - 403: caller non SUPERADMIN. - 404: Comune o cittadino indicati non trovati.
     * @endpoint get /api/v1/gestione/notifiche-push/destinatari
* @param requestParameters
     */
    contaDestinatariNotificaPush(requestParameters: ContaDestinatariNotificaPushRequestParams, extraHttpRequestParams?: any): Observable<NotificaPushDestinatariDTO>;

    /**
     * Storico degli invii di notifiche push (SUPERADMIN, OP_COMUNE)
     * Pagina dello storico, piu\&#39; recenti prima. Un SUPERADMIN vede tutti gli invii; un OP_COMUNE solo gli invii a selezione (&#x60;destinatario_tipo&#x3D;SELEZIONE&#x60;) con &#x60;comune_id&#x60; fra i propri comuni gestiti, anche se lanciati da un collega: i broadcast della piattaforma non compaiono, e il mittente e\&#39; indicato solo da &#x60;mittente_nome&#x60; (mai dall\&#39;email). Ogni riga porta lo stato dell\&#39;invio e i contatori (destinatari, inviati, falliti, token rimossi): &#x60;inviati&#x3D;0&#x60; su molti destinatari indica un fallimento massivo, tipicamente credenziali Firebase non valide.  Risposte: - 200: &#x60;Page&lt;NotificaPushInvioDTO&gt;&#x60;. - 403: caller ne\&#39; SUPERADMIN ne\&#39; OP_COMUNE.
     * @endpoint get /api/v1/gestione/notifiche-push
* @param requestParameters
     */
    getStoricoNotifichePush(requestParameters: GetStoricoNotifichePushRequestParams, extraHttpRequestParams?: any): Observable<PagedModelNotificaPushInvioDTO>;

    /**
     * Invia una notifica push a tutti i cittadini (SUPERADMIN)
     * Avvia l\&#39;invio verso tutti i cittadini con almeno un token registrato, opzionalmente ristretti a un Comune. L\&#39;invio e\&#39; asincrono e IRREVERSIBILE: chiamare prima &#x60;GET /destinatari&#x60; per sapere quanti dispositivi verranno raggiunti.  Semantica del filtro &#x60;comune_id&#x60;: vedi &#x60;GET /destinatari&#x60;.  Risposte: - 202: invio accettato; il body porta &#x60;invio_id&#x60; da consultare nello storico. - 400: payload invalido (titolo o messaggio vuoti). - 403: caller non SUPERADMIN. - 404: Comune indicato non trovato.
     * @endpoint post /api/v1/gestione/notifiche-push/broadcast
* @param requestParameters
     */
    inviaNotificaPushBroadcast(requestParameters: InviaNotificaPushBroadcastRequestParams, extraHttpRequestParams?: any): Observable<{ [key: string]: string; }>;

    /**
     * Invia una notifica push a una selezione di cittadini (SUPERADMIN, OP_COMUNE)
     * Avvia l\&#39;invio verso tutti i dispositivi dei cittadini indicati (da 1 a 50 id distinti; i duplicati sono ridotti a uno prima del controllo del tetto). L\&#39;invio e\&#39; asincrono: la risposta conferma la presa in carico, non il recapito.  Perimetro: i destinatari devono essere cittadini non anonimizzati ne\&#39; bloccati. Per un OP_COMUNE devono inoltre avere almeno una pratica su un bando del comune di perimetro (&#x60;comune_id&#x60;: obbligatorio se ne gestisce piu\&#39; di uno, default se ne gestisce uno solo). Per un SUPERADMIN &#x60;comune_id&#x60; e\&#39; opzionale e, se presente, applica lo stesso vincolo.  Risposte: - 202: invio accettato; il body porta &#x60;invio_id&#x60; da consultare nello storico. - 400: payload invalido, elenco vuoto o oltre 50 id distinti, &#x60;comune_id&#x60; mancante per un OP_COMUNE con piu\&#39; comuni. - 403: caller ne\&#39; SUPERADMIN ne\&#39; OP_COMUNE. - 404: comune fuori perimetro, oppure almeno un cittadino non idoneo o fuori perimetro (l\&#39;intera richiesta e\&#39; rifiutata, senza indicare quale id).
     * @endpoint post /api/v1/gestione/notifiche-push/selezione
* @param requestParameters
     */
    inviaNotificaPushSelezione(requestParameters: InviaNotificaPushSelezioneRequestParams, extraHttpRequestParams?: any): Observable<{ [key: string]: string; }>;

    /**
     * Invia una notifica push a un singolo cittadino (SUPERADMIN)
     * Avvia l\&#39;invio verso tutti i dispositivi su cui il cittadino indicato ha registrato un token. L\&#39;invio e\&#39; asincrono: la risposta conferma la presa in carico, non il recapito.  Risposte: - 202: invio accettato; il body porta &#x60;invio_id&#x60; da consultare nello storico. - 400: payload invalido (titolo o messaggio vuoti). - 403: caller non SUPERADMIN. - 404: utente destinatario non trovato.
     * @endpoint post /api/v1/gestione/notifiche-push/utente
* @param requestParameters
     */
    inviaNotificaPushUtente(requestParameters: InviaNotificaPushUtenteRequestParams, extraHttpRequestParams?: any): Observable<{ [key: string]: string; }>;

}
